import React from 'react';
import { cva } from 'class-variance-authority';
import ErrorMessage from '@/components/common/ErrorMessage';
import { cn } from '@/lib/utils';
import Select from 'react-select';

const inputVariants = cva(
  'rounded-lg border border-[#D9DBE9] text-secondary outline-0 disabled:cursor-not-allowed disabled:opacity-50 db-custom-select',
  {
    variants: {
      variant: { default: '', outline: '' },
      size: {
        default: 'h-12 [&>.db-select__control]:px-4',
        sm: 'h-10 rounded-md text-sm [&>.db-select__control]:px-3',
        lg: 'h-11 rounded-md text-base [&>.db-select__control]:px-4',
      },
    },
    defaultVariants: { variant: 'default', size: 'default' },
  }
);

export const InputSelect = React.forwardRef(
  (
    {
      className,
      groupClassName,
      size,
      variant,
      labelStyleClassName,
      labelClassName,
      labelText,
      options,
      errors,
      id,
      errorType,
      onChange,
      value,
      isSearchable = true,
      // allow overrides but provide good defaults for modals
      menuPortalTarget,
      styles,
      ...props
    },
    ref
  ) => {
    const mergedStyles = {
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      menu:       (base) => ({ ...base, zIndex: 9999 }),
      // keep input height tight
      control:    (base) => ({ ...base, minHeight: 0 }),
      ...styles,
    };

    return (
      <div className={cn('form-input-item', groupClassName)}>
        {labelText && (
          <label
            htmlFor={id}
            className={cn(
              labelStyleClassName ?? 'text-sm capitalize mb-1 text-heading inline-block',
              labelClassName
            )}
          >
            {labelText}
          </label>
        )}

        <Select
          ref={ref}
          className={cn(inputVariants({ size, className, variant }), errorType && 'invalid')}
          classNamePrefix="db-select"
          options={options}
          value={value}
          onChange={onChange}
          isSearchable={isSearchable}
          placeholder="Select Option"
          noOptionsMessage={() => 'Select Option'}
          // ✅ Portal ensures the menu is clickable above modals/overlays
          menuPortalTarget={menuPortalTarget ?? (typeof document !== 'undefined' ? document.body : null)}
          styles={mergedStyles}
          {...props}
        />

        {errorType && <ErrorMessage errorType={errorType} />}
      </div>
    );
  }
);
